import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-dashboard",
  "use": "icon-dashboard-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-dashboard\"><defs><style>#icon-dashboard .cls-1{fill:none;}</style></defs><title></title><g id=\"icon-dashboard_无色底\"><rect id=\"icon-dashboard__矩形_\" data-name=\"&lt;矩形&gt;\" class=\"cls-1\" width=\"16\" height=\"16\" /></g><g id=\"icon-dashboard_图层_1\" data-name=\"图层 1\"><path d=\"M14.35,6.28l-.61.86a7.09,7.09,0,0,1,.41.69l-.86.5a.5.5,0,0,0,.5.87l.78-.45A6.9,6.9,0,0,1,15,11.13H11a3,3,0,0,0-.13-.83l4.33-6.06a.5.5,0,0,0-.7-.7L8.06,8.14H8a3,3,0,0,0-3,3H1v0H1a6.88,6.88,0,0,1,.41-2.33l.74.43a.5.5,0,0,0,.5-.87l-.83-.48A7,7,0,0,1,4.06,5.35v0l.5.87a.5.5,0,0,0,.87-.5l-.5-.87,0,0A7,7,0,0,1,8,4.13H8v1a.5.5,0,0,0,1,0V4.21a7,7,0,0,1,2.49.87l.89-.63A8,8,0,0,0,0,11.13v1H5.18a3,3,0,0,0,5.63,0H16v-1A8,8,0,0,0,14.35,6.28Zm-4,3a3,3,0,0,0-1-.84l3.3-2.36Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/dashboard.svg
// module id = BCGP
// module chunks = 35